import { createStyles, InputBase, withStyles } from '@material-ui/core';
export const BootstrapInput = withStyles((theme) => createStyles({
    input: {
        borderRadius: 4,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        padding: '27px 12px 10px',
        paddingRight: '48px !important',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        cursor: 'pointer',
        '&:focus, &:hover, &.MuiInputBase-inputAdornedEnd:focus ~ *, &.MuiInputBase-inputAdornedEnd:hover ~ *, &.MuiInputBase-inputAdornedEnd ~ *:focus, &.MuiInputBase-inputAdornedEnd ~ *:hover, * ~ &.MuiInputBase-inputAdornedEnd:focus, * ~ &.MuiInputBase-inputAdornedEnd:hover': {
            backgroundColor: theme.palette.background.paper,
            borderColor: theme.palette.primary.main,
            transition: 0,
        },
        '&.Mui-error, &.MuiInputBase-inputAdornedEnd.Mui-error ~ *': {
            borderColor: theme.palette.error.main,
        },
        '.Mui-error &, .Mui-error &.MuiInputBase-inputAdornedEnd ~ *': {
            borderColor: theme.palette.error.main,
        },
        '&.MuiInputBase-inputAdornedEnd': {
            backgroundColor: theme.palette.background.paper,
            borderRight: 'none',
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
        },
        '&.MuiInputBase-inputAdornedEnd ~ *': {
            backgroundColor: theme.palette.background.paper,
            border: '1px solid #ced4da',
            borderLeft: 'none',
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            borderTopRightRadius: 4,
            borderBottomRightRadius: 4,
            height: '100%',
        },
        '&:disabled, &:disabled ~ *': {
            backgroundColor: `${theme.palette.grey["300"]} !important`,
        },
        '#flight-search-filters &:disabled, #flight-search-filters &:disabled ~ *': {
            backgroundColor: `${theme.palette.common.white} !important`,
            color: theme.palette.common.black,
        }
    },
}))(InputBase);
